import React from 'react';
import classNames from 'classnames';

import { Checkbox, Icon } from 'Permafrost/index';
import { FilterOption } from '../../FilterSelect';
import { StyledFilterSelectOptions } from './FilterSelectOptions.styles';

type Props = {
  isMulti: boolean;
  optionsList: FilterOption[];
  selectedFilters: FilterOption[];
  handleOptionClick: (option: FilterOption) => void;
};

export const FilterSelectOptions = ({
  isMulti,
  optionsList,
  selectedFilters,
  handleOptionClick,
}: Props) => {
  return (
    <StyledFilterSelectOptions>
      {optionsList?.map((filterOption: FilterOption) => {
        const { text, value, iconName } = filterOption;

        const selected = selectedFilters?.some((item: FilterOption) => item.value === value);

        return (
          <li
            key={`LabelFilter-${value}`}
            data-testid={`li--filter-list-${value}`}
            className={classNames('option-container', {
              selected,
            })}
            onClick={() => {
              handleOptionClick(filterOption);
            }}
          >
            {isMulti ? (
              <div className="multi-option">
                <Checkbox
                  aria-label={`Checkbox option ${filterOption.value}`}
                  className="option-checkbox"
                  isSelected={selected}
                />
                {text}
              </div>
            ) : (
              <div className="single-option">
                {text}
                {iconName ? (
                  <Icon
                    name={iconName}
                    className="filter__icon"
                    data-testid={`li--filter-list-icon-for-${value}`}
                  />
                ) : null}
                {selected ? (
                  <Icon
                    name="check"
                    className="selected-checkmark"
                    data-testid={`li--filter-list-icon-selected-indicator-for-${value}`}
                  />
                ) : null}
              </div>
            )}
          </li>
        );
      })}
    </StyledFilterSelectOptions>
  );
};
